import HttpsProxyAgent from 'https-proxy-agent';
import https from 'https';
import _url from 'url';
import config from '../../../../config';

import {
  setupJsonJWTHeaders,
  genericHandleApiError,
  requestOk,
} from './api-util';
import {fetchWithTimeout} from './fetch-util';

const jsonBody = (response) => {
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.indexOf('application/json') !== -1) {
    return response.json();
  }
  return null;
};

const getAgent = (url) => {
  if (process.env.HTTP_PROXY) {
    const {hostname} = _url.parse(url);
    if (
      process.env.NO_PROXY &&
      !Object.values(process.env.NO_PROXY.split(',')).some((host) => {
        return hostname.endsWith(host.trim());
      })
    ) {
      return new HttpsProxyAgent(process.env.HTTP_PROXY);
    }
  }
  return new https.Agent({
    rejectUnauthorized: !config.ignoreSelfSignedCert,
  });
};

class HttpUtil {
  static get = (token, url, customHeaders) => {
    return HttpUtil.getReturnPlainResponse(token, url, customHeaders).then(
      (response) => {
        if (requestOk(response)) {
          return jsonBody(response);
        }
        return genericHandleApiError(response);
      },
    );
  };

  static getReturnPlainResponse = (token, url, customHeaders) => {
    const headers = customHeaders || setupJsonJWTHeaders(token);

    const myInit = {
      method: 'GET',
      headers,
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
      agent: getAgent(url),
    };

    return fetchWithTimeout(url, myInit, config.requestTimeout, 'Timeout');
  };

  static post(token, url, body, customHeaders) {
    const headers = customHeaders || setupJsonJWTHeaders(token);

    return HttpUtil.postReturnPlainResponse(token, url, body, headers).then(
      (response) => {
        if (requestOk(response)) {
          return jsonBody(response);
        }
        return genericHandleApiError(response);
      },
    );
  }

  static postReturnPlainResponse(token, url, body, customHeaders) {
    const headers = customHeaders || setupJsonJWTHeaders(token);

    const myInit = {
      method: 'POST',
      headers,
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
      body,
      agent: getAgent(url),
    };
    return fetchWithTimeout(url, myInit, config.requestTimeout, 'Timeout');
  }

  static put(token, url, body, customTimeout) {
    const timeout = customTimeout || config.requestTimeout;

    const myInit = {
      method: 'PUT',
      headers: setupJsonJWTHeaders(token),
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
      body,
      agent: getAgent(url),
    };

    return fetchWithTimeout(url, myInit, timeout, 'Timeout').then(
      (response) => {
        if (requestOk(response)) {
          return jsonBody(response);
        }
        return genericHandleApiError(response);
      },
    );
  }

  static patch(token, url, body, customTimeout) {
    const timeout = customTimeout || config.requestTimeout;

    const myInit = {
      method: 'PATCH',
      headers: setupJsonJWTHeaders(token),
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
      body,
      agent: getAgent(url),
    };

    return fetchWithTimeout(url, myInit, timeout, 'Timeout').then(
      (response) => {
        if (requestOk(response)) {
          return jsonBody(response);
        }
        return genericHandleApiError(response);
      },
    );
  }

  static delete = (token, url) => {
    const myInit = {
      method: 'DELETE',
      headers: setupJsonJWTHeaders(token),
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
      agent: getAgent(url),
    };

    return fetchWithTimeout(url, myInit, config.requestTimeout, 'Timeout').then(
      (response) => {
        if (requestOk(response)) {
          return jsonBody(response);
        }
        return genericHandleApiError(response);
      },
    );
  };
}

export default HttpUtil;
